import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankSuccessPage} from 'features/saved-accounts/pages/ConnectBankSuccessPage';

export const Route = createFileRoute(
  '/_protected/bill-payment/$billId/connect-bank/success',
)({
  component: ConnectBankSuccessPage,
});
